import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TeacherEarningsController::index
* @see app/Http/Controllers/Teacher/TeacherEarningsController.php:22
* @route '/teacher/earnings'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/earnings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherEarningsController::index
* @see app/Http/Controllers/Teacher/TeacherEarningsController.php:22
* @route '/teacher/earnings'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherEarningsController::index
* @see app/Http/Controllers/Teacher/TeacherEarningsController.php:22
* @route '/teacher/earnings'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherEarningsController::index
* @see app/Http/Controllers/Teacher/TeacherEarningsController.php:22
* @route '/teacher/earnings'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const earnings = {
    index: Object.assign(index, index),
}

export default earnings